export const WIRES_CONTAINER_TAG_NAME = 'wires-container';
